export class FuncionalidadPersonalizacionDTO {
    funcionalidadPersonalizacionId: number;
    nombre : string;
    estado : boolean;
    obligatorio : boolean;
    etiquetaId?: number;
}